// assets/collection-progress.js

class CollectionProgress {
  constructor() {
    this.progressEl = document.querySelector('.collection-progress');
    if (!this.progressEl) return;

    this.textEl = this.progressEl.querySelector('.collection-progress__text');
    this.total = parseInt(this.progressEl.dataset.total, 10);
    this.perPage = parseInt(this.progressEl.dataset.perPage, 10);

    // Obserwuj zmiany w gridzie (nowe karty)
    this.grid = document.querySelector('[ref="grid"]');
    if (!this.grid) return;

    this.update(); // Inicjalny render

    const observer = new MutationObserver(() => this.update());
    observer.observe(this.grid, { childList: true });
  }

  update() {
    const cards = this.grid.querySelectorAll('[ref="cards[]"]');
    const shown = cards.length;
    const total = this.total;

    if (!this.textEl) return;

    if (shown >= total) {
      this.textEl.textContent = `Wyświetlono wszystkie ${total} produkty`;
    } else {
      this.textEl.textContent = `Wyświetlono ${shown} z ${total} produktów`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new CollectionProgress());
